<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div
      class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2 sp-product-category__grid">
      <app-product-category-header
        (refresh)="onRefresh()"></app-product-category-header>

      <app-product-category-data (refresh)="onRefresh()"></app-product-category-data>
    </div>
  </div>
</div>
